import { render } from "./PanelsGroup.vue?vue&type=template&id=e0a8a7a0&scoped=true"
import script from "./PanelsGroup.vue?vue&type=script&lang=js"
export * from "./PanelsGroup.vue?vue&type=script&lang=js"

import "./PanelsGroup.vue?vue&type=style&index=0&id=e0a8a7a0&scoped=true&lang=scss"
import "./PanelsGroup.vue?vue&type=style&index=1&id=e0a8a7a0&lang=scss"

import exportComponent from "/codebuild/output/src1366294755/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0a8a7a0"]])

export default __exports__